import { AntdTable, ColumnsType, Progress } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { AAntdTabs } from 'views/components/Analytics'
import { useColumns, useSampleTableData } from './usePartsTableData'
import { LEFT_BLOCK_WIDTH } from 'modules/constants'
import { ExtendedColumnType } from 'modules/types'
import { SamplePartsTab } from '../../types'
import { DownloadAsExcel } from './DownloadAsExcel'
import styled from 'styled-components'

const AbsoluteBtns = styled.div<{ isFullScreen: boolean }>`
  position: absolute;
  right: ${({ isFullScreen }) => (isFullScreen ? '0' : '60px')};
  top: ${({ isFullScreen }) => (isFullScreen ? '0' : '16px')};
`
const PartsTable: FC<{ tabData: SamplePartsTab }> = ({ tabData }) => {
  const tableData = useSampleTableData(tabData)
  const columns = useColumns(tabData)
  let width = (columns as ColumnsType)?.reduce(
    (acc, col) => acc + Number(col.width ?? (col as ExtendedColumnType).autoWidth ?? 0),
    0,
  )
  width = width > LEFT_BLOCK_WIDTH ? width : LEFT_BLOCK_WIDTH
  return (
    <AntdTable
      columns={columns}
      data={tableData ?? []}
      progress={Progress.SUCCESS}
      rowKey="id"
      disablePagination
      outerBordered
      scroll={{ x: width }}
      rowHoverGray
    />
  )
}

type Props = {
  data: SamplePartsTab[]
  sampleId: number
  isFullScreen?: boolean
}

export const SamplePartsTabs: FC<Props> = ({ data, sampleId, isFullScreen = false }) => {
  const items = data.map((dataForTab) => ({
    label: dataForTab.title,
    key: dataForTab.title,
    children: <PartsTable tabData={dataForTab} />,
  }))

  return (
    <div>
      <AAntdTabs id="sample-parts-tabs" items={items} />
      <AbsoluteBtns isFullScreen={isFullScreen}>
        <DownloadAsExcel sampleId={sampleId} />
      </AbsoluteBtns>
    </div>
  )
}
